var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from 'react';
import { Field, useField } from 'react-final-form';
import { Autocomplete, FormHelperText, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { omit } from 'lodash';
import DocumentUploadButton from '../../components/DocumentUploadButton';
import FinalFormDocumentChipWrapper from '../../components/FinalFormDocumentChipWrapper';
import InputLabelWrapper from '../../components/InputLabelWrapper';
var FinalFormDocumentField = function (_a) {
    var _b;
    var name = _a.name, _c = _a.multiple, multiple = _c === void 0 ? false : _c, documentKey = _a.documentKey, documentOptions = _a.documentOptions, muiAutoCompleteProps = _a.muiAutoCompleteProps, buttonProps = _a.buttonProps, uploadButtonProps = _a.uploadButtonProps, fieldProps = _a.fieldProps, containerClasseNames = _a.containerClasseNames, error = _a.error, helperText = _a.helperText, _d = _a.defaultLabelBehaviour, defaultLabelBehaviour = _d === void 0 ? false : _d, label = _a.label, labelClassNames = _a.labelClassNames, required = _a.required, onDocUpload = _a.onDocUpload, getDocumentChipTitle = _a.getDocumentChipTitle, onDocumentKeySelect = _a.onDocumentKeySelect, documentChipProps = _a.documentChipProps, documentChipWrapperClassnames = _a.documentChipWrapperClassnames;
    var _e = __read(useState(null), 2), currentDocumentKey = _e[0], setCurrentDocumentKey = _e[1];
    var meta = useField(name).meta;
    var _f = __read(useState(documentOptions), 2), documentOptionsLocal = _f[0], setDocumentOptionsLocal = _f[1];
    var renderDropDown = !!(!documentKey && Array.isArray(documentOptionsLocal));
    var handleUpload = useCallback(function (file) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (onDocUpload === null || onDocUpload === void 0 ? void 0 : onDocUpload(file))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [name, onDocUpload]);
    useEffect(function () {
        setDocumentOptionsLocal(documentOptions);
    }, [documentOptions]);
    var customSort = function (a, b, rawInput) {
        var inputValue = rawInput.trim().toLowerCase();
        var labelA = a.label.toLowerCase();
        var labelB = b.label.toLowerCase();
        if (labelA.startsWith(inputValue) && labelB.startsWith(inputValue)) {
            return labelA.localeCompare(labelB);
        }
        if (labelA.startsWith(inputValue)) {
            return -1;
        }
        if (labelB.startsWith(inputValue)) {
            return 1;
        }
        return labelA.localeCompare(labelB);
    };
    var onInputChange = function (value, meta) {
        if (meta === 'input') {
            var filteredOptions = documentOptions.sort(function (a, b) { return customSort(a, b, value); });
            setDocumentOptionsLocal(filteredOptions);
        }
        else if (meta === 'clear' || meta === 'reset') {
            setDocumentOptionsLocal(documentOptions);
        }
    };
    var handleDropdownChange = function (_event, value) {
        setCurrentDocumentKey(value);
        onDocumentKeySelect === null || onDocumentKeySelect === void 0 ? void 0 : onDocumentKeySelect(value);
    };
    var InputRenderer = function (params) {
        var _a;
        var inputProps = params.inputProps, restInputProps = __rest(params, ["inputProps"]);
        return (React.createElement(TextField, __assign({}, restInputProps, { label: defaultLabelBehaviour ? label : undefined, error: error !== null && error !== void 0 ? error : (meta.touched && !!meta.error), helperText: (_a = (meta.touched ? meta.error : undefined)) !== null && _a !== void 0 ? _a : helperText, inputProps: __assign({}, inputProps) })));
    };
    return (React.createElement("div", { className: "lfc-flex lfc-items-end ".concat(containerClasseNames !== null && containerClasseNames !== void 0 ? containerClasseNames : '') },
        React.createElement(Field, __assign({ name: name, component: "input" }, fieldProps, { className: "lfc-hidden" })),
        renderDropDown ? (React.createElement(FinalFormDocumentChipWrapper, __assign({ name: name, getDocumentChipTitle: getDocumentChipTitle, multiple: multiple, documentChipWrapperClassnames: documentChipWrapperClassnames }, documentChipProps),
            React.createElement("div", { className: "lfc-flex lfc-flex-col" },
                !defaultLabelBehaviour && (React.createElement(InputLabelWrapper, { label: label, required: required, className: labelClassNames })),
                React.createElement(Box, { className: "lfc-upload-dropdown-button-container lfc-flex" },
                    React.createElement(Autocomplete, __assign({ options: documentOptionsLocal !== null && documentOptionsLocal !== void 0 ? documentOptionsLocal : [] }, muiAutoCompleteProps, { value: currentDocumentKey, onChange: handleDropdownChange, renderInput: InputRenderer, onInputChange: function (event, value, reason) {
                            onInputChange(value, reason);
                        } })),
                    React.createElement(DocumentUploadButton, __assign({ onUpload: handleUpload, buttonProps: __assign({ disabled: renderDropDown && !currentDocumentKey, sx: { marginX: 2 } }, uploadButtonProps === null || uploadButtonProps === void 0 ? void 0 : uploadButtonProps.buttonProps) }, omit(uploadButtonProps, 'buttonProps'))))))) : (React.createElement(FinalFormDocumentChipWrapper, __assign({ name: name, getDocumentChipTitle: getDocumentChipTitle, multiple: multiple }, documentChipProps),
            React.createElement(Box, { className: "lfc-upload-button-container" },
                React.createElement(InputLabelWrapper, { label: label, required: required, className: labelClassNames }),
                React.createElement(DocumentUploadButton, __assign({ onUpload: handleUpload, buttonProps: __assign(__assign({ disabled: renderDropDown && !currentDocumentKey }, ((error !== null && error !== void 0 ? error : (meta.touched && !!meta.error)) ? { sx: { border: '1px solid #d32f2f' } } : {})), uploadButtonProps === null || uploadButtonProps === void 0 ? void 0 : uploadButtonProps.buttonProps) }, omit(uploadButtonProps, 'buttonProps'))),
                helperText || meta.error ? (React.createElement(FormHelperText, { sx: __assign({}, ((error !== null && error !== void 0 ? error : (meta.touched && !!meta.error)) ? { color: '#d32f2f' } : {})) }, (_b = (meta.touched ? meta.error : undefined)) !== null && _b !== void 0 ? _b : helperText)) : undefined)))));
};
export default FinalFormDocumentField;
//# sourceMappingURL=FinalFormDocumentField.js.map